module.exports = __webpack_public_path__ + "static/patient-maria-profile-img-420dc408d9d025beec5863310b06ef31.png";